// TECH POSTERS
import linesyncPoster from "../assets/images/posters/Design Posters/Tech/linesync.jpg";
import paperxPoster from "../assets/images/posters/Design Posters/Tech/paperx.webp";
import techversePoster from "../assets/images/posters/Design Posters/Tech/techverse.webp";
import compilexPoster from "../assets/images/posters/Design Posters/Tech/compilex.jpg";
import auctioneerPoster from "../assets/images/posters/Design Posters/Tech/auctioneer.jpg";
import artifactPoster from "../assets/images/posters/Design Posters/Tech/artifactrush.webp";
import logicPoster from "../assets/images/posters/Design Posters/Tech/logic-lies.jpg";
import phonetix from "../assets/images/posters/Design Posters/Tech/phonetix.webp";
// NON TECH POSTERS
import shuttlePoster from "../assets/images/posters/Design Posters/Non Tech/shuttle-blasters.jpg";
import lbwPoster from "../assets/images/posters/Design Posters/Non Tech/lbw.jpg";
import tamilPoster from "../assets/images/posters/Design Posters/Non Tech/tamil.webp";
import saregamaPoster from "../assets/images/posters/Design Posters/Non Tech/saregama.webp";
import huntxPoster from "../assets/images/posters/Design Posters/Non Tech/huntx.jpg";
import cricbidPoster from "../assets/images/posters/Design Posters/Non Tech/cricbid.jpg";
import cinemaPoster from "../assets/images/posters/Design Posters/Non Tech/cinema.jpg";
import carnivalPoster from "../assets/images/posters/Design Posters/Non Tech/carnival.jpg";
import odyssey from "../assets/images/posters/Design Posters/Non Tech/odyssey.jpg";
// ==============================
// TECH EVENTS
// ==============================

export const techEvents = [
  {
    title: "LineSync – Line Tracer Challenge",
    poster: linesyncPoster,

    shortDesc:
      "Design and race your line-tracing robot to achieve the fastest completion time in this exciting robotics challenge.",

    details: [
      "Team Size: 2–4 members",
      "Max Bot Dimension: 30 cm",
      "Max Battery Voltage: 12V",
      "Track Width: 3.5 cm",
      "Fastest completion time wins",
    ],

    date: "13 March 2026",
    venue: "1st Floor JC Bose Block, ECE Department",

    link: "https://forms.gle/okK2c1dm5ggQLEY38",

    contact: [
      { name: "Ragul S", phone: "8122071578" },
      { name: "Thiruvikesh", phone: "9361508940" },
    ],
  },

  {
    title: "PAPERX – Technical Paper Presentation",
    poster: paperxPoster,

    shortDesc:
      "Present your research ideas and showcase technical innovation through impactful presentations and discussions.",

    details: [
      "Team Size: 2–4 members",
      "Presentation: 8 minutes",
      "Q&A Session: 2 minutes",
      "Research and innovation focused event",
    ],

    deadline: "10 March 2026",
    date: "13 March 2026",
    venue: "MPMC Lab, ECE Department",

    link: "https://forms.gle/MZmcbY2Rsve4hoTm7",

    contact: [
      { name: "Ragul S", phone: "8122071578" },
      { name: "Jayapradaa", phone: "8220108381" },
    ],
  },

  {
    title: "TECHVERSE",
    poster: techversePoster,

    shortDesc:
      "A technical quiz exploring futuristic technologies from AI and robotics to advanced communication systems.",

    details: [
      "Technology themed quiz event",
      "Covers AI, Robotics, BCI, Energy and Communication",
      "Tests technical knowledge and analytical thinking",
      "Team based competition",
    ],

    date: "13 March 2026",
    venue: "1st Floor Lecture Hall, ECE Department",

    link: "https://forms.gle/6oLqrPbb1DCxZhUz5",

    contact: [
      { name: "Ragul S", phone: "8122071578" },
      { name: "Uthaya Laxmi", phone: "7010424609" },
    ],
  },

  {
    title: "COMPILEX – Coding Challenge",
    poster: compilexPoster,

    shortDesc:
      "A competitive coding event where logic, speed, and problem-solving skills determine the champion.",

    details: [
      "Competitive programming contest",
      "Algorithm and problem-solving challenges",
      "Real-time coding pressure",
      "Open to all coding enthusiasts",
    ],

    date: "14 March 2026",
    venue: "1st Floor Lecture Hall, ECE Department",

    link: "https://forms.gle/qWKDK4mkibcPc5DH6",

    contact: [
      { name: "Ragul S", phone: "8122071578" },
      { name: "Jayapradaa R", phone: "8220108381" },
    ],
  },

  {
    title: "The Auctioneer’s Lab – Build, Bid, Solve",
    poster: auctioneerPoster,

    shortDesc:
      "A strategic electronics challenge where teams bid for components and build a working embedded solution.",

    details: [
      "Component bidding strategy challenge",
      "Build a functional embedded circuit",
      "Balance budget and performance",
      "Hands-on engineering event",
    ],

    date: "13 March 2026",
    venue: "1st Floor Lecture Hall, ECE Department",

    link: "https://forms.gle/bqXd2AahaLcNHRr5A",

    contact: [
      { name: "Ragul S", phone: "8122071578" },
      { name: "Nagarjuna", phone: "9361730437" },
    ],
  },
  {
  title: "Artifact Rush",
  poster: artifactPoster,

  shortDesc:
    "A dynamic two-round challenge combining technical knowledge, logical reasoning, and teamwork.",

  details: [
    "Two-round technical puzzle challenge",
    "Analytical reasoning and pattern decoding",
    "Problem-solving under time pressure",
    "Open to all years",
  ],

  date: "13 March 2026",
  venue: "2nd Floor Lecture Hall, ECE Department",

  link: "https://forms.gle/6Jd191jiQNKcsEG19",

  contact: [
    { name: "Ragul S", phone: "8122071578" },
    { name: "Aadithyan", phone: "7550115405" },
  ],
},
{
  title: "Logic & Lies",
  poster: logicPoster,

  shortDesc:
    "A mystery challenge where participants decode clues, solve logical trials, and uncover a hidden 10-digit secret.",

  details: [
    "Multiple puzzle and logic challenges",
    "Decode clues and hidden patterns",
    "Final goal: uncover the 10-digit secret code",
  ],

  date: "14 March 2026",
  venue: "1st Floor Lecture Hall, ECE Department",

  link: "https://forms.gle/VCBMw9gxEiM4mUTP8",

  contact: [
    { name: "Ragul S", phone: "8122071578" },
    { name: "Uthaya Laxmi A P", phone: "8807060121" },
  ],
},
{
  title: "PHONETIX",
  poster: phonetix,

  shortDesc:
    "Control a robot using voice commands through a mobile app and guide it through a challenging obstacle track.",

  details: [
    "Team Size: 1–2 members",
    "Voice-controlled bot using mobile application",
    "Bot Size Limit: 25 cm × 25 cm",
    "Maximum 3 touch assists allowed",
    "Speed and accuracy determine the winner"
  ],

  date: "14 March 2026",
  venue: "1st Floor, JC Bose Block, ECE Department",

  link: "https://forms.gle/pXN5Dk1gyspYXrn59",

  contact: [
    { name: "Ragul S", phone: "8122071578" },
    { name: "Hariharan", phone: "7812857905" }
  ]
}
];

// ==============================
// NON TECH EVENTS
// ==============================

export const nonTechEvents = [
  {
    title: "Shuttle Blasters",
    poster: shuttlePoster,

    shortDesc:
      "A fun and competitive badminton doubles tournament conducted as part of Vision Premier League 2026.",

    details: [
      "Format: Doubles",
      "Categories: Boys Doubles & Girls Doubles",
      "Team Size: 2 players",
      "Entry Fee: ₹100 per team",
      "Winning Prize: ₹2000",
    ],

    deadline: "15 February 2026",

    link: "https://docs.google.com/forms/d/e/1FAIpQLScm577ejmggfECvy3CsYcqYulQ4eBwwwwqVW2xtYBro_3Ljaw/closedform",

    contact: [
      { name: "Logeshwaran", phone: "7598751541" },
      { name: "Anitha", phone: "9384231428" },
    ],
  },

  {
    title: "Love Beyond Wicket (LBW)",
    poster: lbwPoster,

    shortDesc:
      "An electrifying cricket event celebrating teamwork, passion, and the true spirit of the game.",

    details: [
      "Team-based cricket tournament",
      "Open to all departments",
      "High-energy competitive matches",
    ],

    fee: "₹300",
    prize: "₹3000",
    deadline: "10 February 2026",

    link: "https://forms.gle/TG91gMEbbJz21ER6A",

    contact: [
      { name: "Darshan N A", phone: "9342654849" },
      { name: "Divya Darshan V R", phone: "9092109353" },
    ],
  },

  {
    title: "தமிழோடு விளையாடு (Tamilodu Vilayadu)",
    poster: tamilPoster,

    shortDesc:
      "A vibrant Tamil quiz celebrating stories, poems, history, and the richness of Tamil language.",

    details: [
      "Team Size: 2 members",
      "Open to all departments and colleges",
      "Quiz based on Tamil literature, history and culture",
    ],

    date: "13 March 2026",
    time: "9:30 AM – 12:30 PM",
    venue: "Maxwell Auditorium, ECE Department",

    link: "https://forms.gle/dS5vucrTqJDW61J69",

    contact: [
      { name: "Divya Darshan VR", phone: "9092109353" },
      { name: "Naveen Raja S", phone: "9092721868" },
    ],
  },

  {
    title: "Sa Re Ga Ma Pa",
    poster: saregamaPoster,

    shortDesc:
      "A musical challenge where teams identify songs, composers, and tunes from quick audio clues.",

    details: [
      "Music identification challenge",
      "Includes classics and modern hits",
      "Fast-paced listening rounds",
      "Team-based competition",
    ],

    date: "14 March 2026",
    time: "9:30 AM – 12:30 PM",
    venue: "ECE Department",

    link: "https://docs.google.com/forms/d/e/1FAIpQLSdY5IUoI4tmWEWzE9K3jLj66MeI-GzKqVb0TAteGSuJ9e-Cww/viewform",

    contact: [
      { name: "Divya Darshan VR", phone: "9092109353" },
      { name: "Shraeya", phone: "9845972416" },
    ],
  },

  {
    title: "HuntX",
    poster: huntxPoster,

    shortDesc:
      "A thrilling treasure hunt where teams decode clues and race across locations to finish the challenge first.",

    details: [
      "Clue-solving treasure hunt",
      "Strategy and teamwork based challenges",
      "Multiple mystery locations",
      "Team Size: Maximum 2 members",
    ],

    date: "14 March 2026",
    time: "9:30 AM – 12:30 PM",
    venue: "ECE Department",

    link: "https://forms.gle/ohoLoEe4rC9FDRAWA",

    contact: [
      { name: "Divya Darshan VR", phone: "9092109353" },
      { name: "Vishnu Prasannaa V", phone: "9500906688" },
    ],
  },

  {
    title: "CricBid",
    poster: cricbidPoster,

    shortDesc:
      "An IPL-style auction event where teams build their dream cricket squad using strategy and sports knowledge.",

    details: [
      "IPL-style player auction",
      "Strategy-based team building",
      "Sports knowledge challenge",
      "Team Size: Maximum 3 members",
    ],

    date: "14 March 2026",
    time: "9:30 AM – 12:30 PM",
    venue: "GF LH1, ECE Department",

    link: "https://forms.gle/2ZwU6766iHQbULfQ6",

    contact: [
      { name: "Divya Darshan VR", phone: "9092109353" },
      { name: "Vishnu Prasannaa V", phone: "9500906688" },
    ],
  },

  {
    title: "Cinema Symphony",
    poster: cinemaPoster,

    shortDesc:
      "A dynamic movie quiz testing observation, memory, and teamwork through engaging cinematic challenges.",

    details: [
      "Visual movie quiz rounds",
      "Observation and memory challenges",
      "Strategy-based team tasks",
      "Team Size: 3 members",
    ],

    date: "13 March 2026",
    time: "9:30 AM – 12:30 PM",
    venue: "GF LH-1, ECE Department",

    link: "https://forms.gle/JYidcBwGAyiM84W88",

    contact: [
      { name: "Divya Darshan VR", phone: "9092109353" },
      { name: "Naveen Raja S", phone: "9092721868" },
    ],
  },
{
  title: "Odyssey",
  poster: odyssey,

  shortDesc:
    "A travel-themed quiz exploring world landmarks, cultures, flags, and global destinations.",

  details: [
    "Travel and geography themed quiz",
    "Questions on landmarks, cultures, flags and currencies",
    "Interactive map-based challenges",
    "Team Size: 1–3 members"
  ],

  date: "13 March 2026",
  time: "10:00 AM – 12:30 PM",
  venue: "Mini Auditorium, ECE Department",

  link: "https://forms.gle/9kni537eBSDiQ6Qz8",

  contact: [
    { name: "Divya Darshan VR", phone: "9092109353" },
    { name: "Manoranjan U", phone: "9788687286" }
  ],

  posterCredits: "Kaviya M (2nd Year)",
  contentCredits: "Vishnu Prasanna (2nd Year)"
}
];
